<template>
    <div class="modal fade" :id="id" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content modal-content-scv-FRONTENDEX-MOBILE-APP">
                <div class="modal-body modal-body-scv-FRONTENDEX-MOBILE-APP">
                    <span v-html="messageText"></span>
                </div>
                <div class="d-flex justify-content-start flex-column flex-fill">
                    <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                    <button class="scv-btn-color-modal-FRONTENDEX-MOBILE-APP scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP-message" type="button" @click="onBtnOk(id)">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        components: {
        },
        props: {
            id: String,
            messageText: String,
        },
        emits: [
            'onBtnOk'
        ]
    })

    // メッセージダイアログコンポーネント
    export default class MessageDialog extends Vue {

        /**
         * @brief   OKボタン押下
         */
        public onBtnOk(id: string): void {
            BootstrapUtil.hideModal(id);
            this.$emit('onBtnOk');
        }

    }

</script>

<style scoped>
    .scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP-message {
        border-radius: 14px;
        border: none;
        height: 44px;
    }
</style>
